import React from 'react';
import { motion } from 'framer-motion';
import AssignmentIcon from '@mui/icons-material/Assignment';
import TimerIcon from '@mui/icons-material/Timer';
import QuestionAnswerIcon from '@mui/icons-material/QuestionAnswer';

const QuizCard = ({ quiz, onClick }) => {
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    });
  };

  return (
    <motion.div
      whileHover={{ scale: 1.02 }}
      whileTap={{ scale: 0.98 }}
      onClick={onClick}
      className="bg-white/80 dark:bg-gray-900/80 backdrop-blur-lg rounded-2xl shadow-lg border border-gray-200/50 dark:border-gray-700/50 p-6 cursor-pointer transition-all duration-200 hover:shadow-xl"
    >
      <div className="flex items-start justify-between mb-4">
        <div className="flex items-center gap-3">
          <div className="p-3 bg-gradient-to-r from-purple-500 to-pink-500 rounded-xl">
            <AssignmentIcon className="text-white text-xl" />
          </div>
          <div>
            <h3 className="font-semibold text-gray-800 dark:text-gray-200">
              {quiz.title || 'Quiz'}
            </h3>
            <p className="text-sm text-gray-600 dark:text-gray-400">
              {quiz.subject || 'Subject'}
            </p>
          </div>
        </div>
      </div>

      <div className="space-y-3">
        <div className="flex items-center gap-2 text-sm text-gray-600 dark:text-gray-400">
          <QuestionAnswerIcon className="text-purple-500" fontSize="small" />
          <span>{quiz.questions?.length || 0} Questions</span>
        </div>
        
        <div className="flex items-center gap-2 text-sm text-gray-600 dark:text-gray-400">
          <TimerIcon className="text-orange-500" fontSize="small" />
          <span>~{Math.ceil((quiz.questions?.length || 0) * 1.5)} minutes</span>
        </div>

        {quiz.created_at && (
          <div className="text-xs text-gray-500 dark:text-gray-500">
            Created: {formatDate(quiz.created_at)}
          </div>
        )}
      </div>

      <div className="mt-4 pt-4 border-t border-gray-200 dark:border-gray-700">
        <div className="flex items-center justify-between">
          <span className="text-sm font-medium text-purple-600 dark:text-purple-400">
            Ready to start
          </span>
          <div className="w-2 h-2 bg-green-500 rounded-full"></div>
        </div>
      </div>
    </motion.div>
  );
};

export default QuizCard; 